import axios from 'axios'
import config from '../config/urls'

const api = axios.create({
    baseURL: config.BASE_URL, headers: {
        'Content-Type': 'application/json; charset=UTF-8'
    }
})

export default api